// extracted by mini-css-extract-plugin
export default {"content_container":"LoginAttempt_content_container__e3nFt","content":"LoginAttempt_content__K5JZ9","background_red":"LoginAttempt_background_red__XGeFt"};